import { useContext } from "react";
import { DamageGlassSelector } from "../components/DamageGlassSelector";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { t } from "../i18n";
import { useWizardNavigation } from "../hooks/useWizardNavigation";
import { TrustMessage } from "../components/TrustMessage";

export function DamageGlass() {
	const { data, isTransitioning } = useContext(AppContext);
	const { nextPage, previousPage } = useWizardNavigation();

	return (
		<>
			<Header />
			<Content data={data} isTransitioning={isTransitioning} />
			<Footer
				nextPage={nextPage}
				previousPage={previousPage}
				clearOnBack={["damageGlass"]}
			/>
		</>
	);
}

function Content({ data, isTransitioning }) {
	return (
		<div className="Wrapper">
			<TrustMessage iconName="car" text="Después de confirmar tu cita, nuestros especialistas se encargarán del resto." />

			<div
				className={
					"content kensei_03" + (isTransitioning ? " fade-in" : "")
				}
			>
				<div className="content_damage_glass">
					<div className="content_title">
						<h2 className="select_damage_glass">
							<strong>{t("Selecciona el cristal dañado")}</strong>
						</h2>
					</div>
					<DamageGlassSelector />
					<span
						className={
							"selected_damage_glass kensei_03" +
							(data.damageGlass ? "" : " hidden opacity-0")
						}
					>
						{data.damageGlass && t(data.damageGlass)}
					</span>
				</div>
			</div>
		</div>
	);
}
